import React from "react";
import { withTranslation } from 'react-i18next'
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';

import Footer from "../../../Footer/FooterBottom";
import UserForm from "./Forms/Step1";
import SchoolForm from "./Forms/Step2";
import SchoolUserForm from "./Forms/Step3";
import CardForm from "./Forms/Step4";
import { getGeoInfo } from "../../../../api/api";
import Backgrounds from "../../../Admin/Question/View/Background";

class SchoolRegister extends React.Component {

    state = {
        Address: "",
        country_code: "",
        showContact: false,
        data: {},
        step: 2
    };

    constructor(props) {
        super(props);
        getGeoInfo().then((response) => {
            if (response && response.data) {
                this.setState({
                    country_code: response.data.country.toLowerCase(),
                    Address: response.data.region
                });
            }
        });
    }

    componentDidMount() {
        window.scrollToPosition("school-register-section");
    }

    goBack = () => {
        if (this.state.step > 1) {
            this.setState({
                step: this.state.step - 1
            });
        }
    }

    goNext = data => {
        this.setState({
            data: { ...data },
            step: this.state.step + 1
        });
    }

    showContact = () => {
        this.setState({
            showContact: true
        }, () => {
            window.Sprintful.initIframe();
        });
    }
    handleClose = () => {
        this.setState({
            showContact: false
        });
    }

    renderForm = () => {
        if (this.state.step === 1)
            return <UserForm onSubmit={this.goNext} goBack={this.goBack} />;
        else if (this.state.step === 2)
            return <SchoolForm onSubmit={this.goNext} goBack={this.goBack} />;
        else if (this.state.step === 4)
            return <CardForm onSubmit={this.goNext} goBack={this.goBack} />;
        else if (this.state.step === 3)
            return <SchoolUserForm
                onSubmit={this.goNext}
                goBack={this.goBack}
                country_code={this.state.country_code}
                Address={this.state.Address} />;
    }

    renderPoint = state => {
        if (state === 1) {
            return <div>
                <i className="fa-regular fa-circle-check text-primary fa-xl"></i>
            </div>
        } else if (state === 2) {
            return <div>
                <i className="fa-regular fa-circle-dot text-primary fa-xl"></i>
            </div>
        }
        return <div>
            <i className="fa-regular fa-circle fa-xl text-secondary"></i>
        </div>
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.Register.School.title')} | {t('alarabeyya')}
                    </title>
                    <script type="text/javascript" src="https://app.sprintful.com/widget/v1.js"></script>
                    <link href="https://app.sprintful.com/widget/v1.css" rel="stylesheet"></link>
                </Helmet>
                <section className="pos-rel call-in-action call-overlay oh" id="school-register-section" style={{
                    backgroundColor: '#75cdff',
                    borderBottom: '1px solid #0e2c53',
                    minHeight: '100vh'
                }}>

                    <div className="position-relative padding-bottom padding-top" style={{
                        minHeight: '100vh'
                    }}>
                        <Backgrounds CustomBackground="Registration" />
                        <div className="container h-100" >
                            {
                                this.state.step === 0 ?
                                    <>

                                        {
                                            this.state.showContact ?
                                                <Modal
                                                    size="xl"
                                                    show={this.state.showContact}
                                                    onHide={this.handleClose}
                                                    backdrop="static"
                                                    keyboard={false}
                                                    enforceFocus={false} >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title> <i className="icon fa-light fa-handshake-angle"></i> {t('Pages.Register.Contact')} </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className="widget">
                                                            <div className="widget-body">
                                                                <div
                                                                    className="sprintful-inline-widget"
                                                                    data-copy-parents-query="false"
                                                                    data-url="https://on.sprintful.com/alarabeyya?hide-logo=false&hide-message=false"
                                                                    style={{
                                                                        minWidth: '320px',
                                                                        height: '80vh'
                                                                    }}></div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                                : ""
                                        }
                                        <div className="row justify-content-center">
                                            <div className="col-lg-8 featured-block">
                                                <div className="inner-box d-flex flex-wrap justify-content-center p-0 " >
                                                    <div className="section-header mb-0 p-5 ">
                                                        <h3 className="title mb-3">
                                                            <i className="fal fa-school "></i>
                                                            {t('Pages.Register.School.title')}
                                                        </h3>

                                                        <span title={t('Pages.Register.School.desc')} className="cate mb-0 d-flex flex-wrap align-items-center justify-content-center" style={{
                                                            fontSize: '20px'
                                                        }}>
                                                            {t('Pages.Register.School.desc')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row clearfix justify-content-center">
                                            <div className="featured-block col-lg-5 col-sm-6 " onClick={() => this.showContact()} >
                                                <div className="inner-box wow fadeInLeft animated" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                                    <span className="border-one"></span>
                                                    <span className="border-two"></span>
                                                    <div className="icon-box d-flex justify-content-center flex-column cursor-pointer">
                                                        <span className="icon"> <i className=" fa-light fa-handshake-angle display-4 text-white"></i></span>
                                                    </div>
                                                    <h5 className="cursor-pointer"> {t("Pages.Register.Contact")}</h5>

                                                    <h5 className="cursor-pointer text-dark" style={{
                                                        fontSize: '16px'
                                                    }}  >{t('Pages.Register.Contact_desc')}</h5>

                                                </div>
                                            </div>
                                            <div className="featured-block col-lg-5 col-sm-6 " onClick={() => this.goNext()}>
                                                <div className="inner-box wow fadeInLeft animated" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                                    <span className="border-one"></span>
                                                    <span className="border-two"></span>
                                                    <div className="icon-box d-flex justify-content-center flex-column cursor-pointer">
                                                        <span className="icon"> <i className=" fa-light fa-school-flag display-4 text-white"></i></span>
                                                    </div>
                                                    <h5 className="cursor-pointer"> {t("Pages.Register.Now")}</h5>
                                                    <h5 className="cursor-pointer text-dark" style={{
                                                        fontSize: '16px'
                                                    }}  >{t('Pages.Register.Now_desc')}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="widget widget-category col-xl-8 mx-auto">
                                            <div className="widget-header">
                                                <h5 className="title">
                                                    <i className="fal fa-school "></i> {t('Pages.Register.School.title')}
                                                </h5>

                                                <div className="position-absolute" style={{
                                                    top: '20px',
                                                    left: '20px'
                                                }}>
                                                    <Link to="/Register" className="btn btn-dark" title={t('Pages.Register.Subscriptions')}>
                                                        <i className="fal fa-arrow-right"></i> <span className="d-none d-lg-inline-block"> {t('Pages.Register.Subscriptions')} </span>
                                                    </Link>
                                                </div>

                                            </div>
                                            <div className="widget-body">

                                                <div className="d-flex justify-content-between align-items-center mb-3 px-2">
                                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                                        {
                                                            this.renderPoint(this.state.step === 1 ? 2 : this.state.step >= 1 ? 1 : 0)
                                                        }
                                                    </div>
                                                    <div className="d-flex align-items-center" style={{ flex: 1, justifyContent: 'space-evenly' }}>
                                                        <i className={`fa-solid fa-arrow-left fa-xs  ${this.state.step >= 2 ? "text-primary" : "text-secondary"}`}></i>
                                                        <i className={`fa-solid fa-arrow-left fa-xs  ${this.state.step >= 2 ? "text-primary" : "text-secondary"}`}></i>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                                        {
                                                            this.renderPoint(this.state.step === 2 ? 2 : this.state.step >= 2 ? 1 : 0)
                                                        }
                                                    </div>
                                                    <div className="d-flex align-items-center" style={{ flex: 1, justifyContent: 'space-evenly' }}>
                                                        <i className={`fa-solid fa-arrow-left fa-xs  ${this.state.step >= 3 ? "text-primary" : "text-secondary"}`}></i>
                                                        <i className={`fa-solid fa-arrow-left fa-xs  ${this.state.step >= 3 ? "text-primary" : "text-secondary"}`}></i>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                                        {
                                                            this.renderPoint(this.state.step === 3 ? 2 : this.state.step >= 3 ? 1 : 0)
                                                        }
                                                    </div>
                                                    <div className="d-flex align-items-center" style={{ flex: 1, justifyContent: 'space-evenly' }}>
                                                        <i className={`fa-solid fa-arrow-left fa-xs  ${this.state.step >= 4 ? "text-primary" : "text-secondary"}`}></i>
                                                        <i className={`fa-solid fa-arrow-left fa-xs  ${this.state.step >= 4 ? "text-primary" : "text-secondary"}`}></i>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                                        {
                                                            this.renderPoint(this.state.step === 4 ? 2 : this.state.step >= 4 ? 1 : 0)
                                                        }
                                                    </div>
                                                </div>
                                                {this.renderForm()}

                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </section >
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

export default withTranslation('common')(SchoolRegister);